import React from "react";
import ACard from "../../Materials/ACard";
import Card from "../../Materials/Card";

import classes from "../../../styles/FetchBlog.module.css";

const FetchBlog = (props) => {
 

  return (
 
     <div className={classes.paraList}>
      {props.fetchPara.map((item) => (
        <div className={classes.div} key={item.id}>
          <div className={classes.textDiv}>
            <div>
              <h2>{item.title}</h2>
            </div>
            <div>
              <p>{item.para}</p>
            </div>
          </div>
          <div className={classes.imgDiv}>
            <img
              src="https://images.unsplash.com/photo-1648071218468-48852c43e004?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
              alt="Image"
            />
          </div>
        </div>
      ))}
    </div> 
 
  );
};

export default FetchBlog;
